import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngx-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {


  @Input() spacer: string | boolean = true;
  _spacer: boolean = true;

  constructor() {

  }

  ngOnInit() {
    if(this.spacer == false || this.spacer == "false"){
      this._spacer = false;
    }else{
      this._spacer = true;
    }
  }


}
